module.exports = __webpack_public_path__ + "img/05.76d33acb.jpg";